import { Box, Container, Grid, Stack } from '@mui/material';
import dataInfuserLogoImage from '../../assets/imgs/home/data_infuser_logo.png';
import InfuserImageHighlight from './InfuserImageHighlight';
import LogoCarousel from './LogoCarousel';
import SlideImageCarousel from '../../components/carousel/SlideImageCarousel';
import styles from './dataInfuserSummary.module.css';
export default function DataInfuserSummary() {
  return (
    <Box component="div" className={`home-item data-infuser-summary`}>
      <Box component="div" className={styles.mainContentWrapper}>
        <Box component="div" className={styles.mainContent}>
          <Container className={styles.mainContentTop} maxWidth={false}>
            <Box component="div" className={styles.mainContentTopLeft}>
              <Box maxWidth="xl">
                <Box className={styles.InfuserImageHighlightWrapper}>
                  <InfuserImageHighlight />
                </Box>
              </Box>
            </Box>
            <Box component="div" className={styles.mainContentTopRight}>
              <Grid container>
                <Box display={'flex'} justifyContent={'center'} order={{}}>
                  <Box component={'img'} className={styles.dataInfuserLogo} src={dataInfuserLogoImage} loading="lazy" />
                </Box>
                <Box>
                  <Box component="div">
                    <Box component={'div'} className="title" sx={{ mb: '20px' }}>
                      <Box component={'div'}>
                        <Box component={'span'} className="bold">
                          코드 없이
                        </Box>
                        여는
                      </Box>
                      <Box component={'span'}> 오픈API의 새 시대</Box>
                    </Box>
                    <Box component={'div'} className="sub">
                      <Box component={'div'}>개발 지식이 없는 사용자도 쉽게 웹 UI를 통해 관리할 수 있게 하는</Box>
                      <Box component={'div'}>
                        <Box component="span" className="bold-1">
                          노코딩{' '}
                        </Box>
                        <Box component="span" className="bold-2">
                          접근 방식
                        </Box>
                        <Box component="span">을 제공합니다.</Box>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Grid>
            </Box>
          </Container>
          <Box component="div" className={styles.mainContentBottom}>
            <Box
              className="description"
              sx={{
                height: '24px',
                alignSelf: 'stretch',
                textAlign: 'center',
                fontSize: '18px',
                fontWeight: '400',
                lineHeight: '24px',
                marginBottom: '29px',
              }}
            >
              <Box component={'span'}>16개의 </Box>
              <Box component={'span'} sx={{ fontWeight: '700' }}>
                정부부처 및 공공기관
              </Box>
              <Box component={'span'}>에 </Box>
              <Box component={'span'} sx={{ fontWeight: '700' }}>
                Data Infuser 도입{' '}
              </Box>
              <Box component={'span'}>되어있고 20개 이상의 고객사를 유치하고 있습니다</Box>
            </Box>
            <Box component={'div'} className="logo-carousel">
              <LogoCarousel />
            </Box>
          </Box>
        </Box>
      </Box>
      <Box component="div" className={styles.mainContentMobileWrapper}>
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          {/* (1) 아이콘 */}
          <Box display="flex" justifyContent="flex-start">
            <Box component="img" className={styles.dataInfuserLogo} src={dataInfuserLogoImage} loading="lazy" />
          </Box>

          {/* (2) 설명글 */}
          <Box>
            <Box className={styles.title}>
              <Box>
                <span className={styles.bold}>코드 없이</span> 여는
              </Box>
              <Box>오픈API의 새 시대</Box>
            </Box>
            <Box className={styles.sub}>
              <Box>개발 지식이 없는 사용자도 쉽게 관리할 수 있게 해주는</Box>
              <Box>
                <span className={styles.bold}>노코딩 접근 방식</span>을 제공합니다.
              </Box>
            </Box>
          </Box>

          {/* (3) 슬라이드 캐러셀 */}
          <Box className={styles.slideImageWrapper}>
            <SlideImageCarousel />
          </Box>

          {/* (4) 하단 설명 텍스트 */}
          <Box className={styles.description}>
            <Box>
              <span>16개의 </span>
              <span className={styles.bold}>정부부처 및 공공기관</span>
              <span>에</span>
            </Box>
            <Box>
              <span className={styles.bold}>Data Infuser 도입</span>되어있고
            </Box>
            <Box>
              <span>20개 이상의 고객사를 유치하고 있습니다</span>
            </Box>
          </Box>

          {/* (5) 로고 캐러셀 */}
          <Box className="logo-carousel">
            <LogoCarousel />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
